import { Disposable } from '@patsnap/tahiti-core/common/disposable';
import { tryOnScopeDispose } from '@vueuse/core';
export function useDisposes() {
    const disposes = [];
    function manualDispose() {
        disposes.forEach(_ => _.dispose());
        disposes.length = 0;
    }
    function addDispose(dispose) {
        disposes.push(Disposable.create(dispose));
    }
    tryOnScopeDispose(manualDispose);
    return {
        disposes,
        manualDispose,
        addDispose,
    };
}
